import { useState } from "react";
import {
  CaseAppealListPaginatedResult,
  CaseAppealListRow,
} from "../../../data-model/caseAppealsTable";

export interface CaseAppealsTableState {
  data: CaseAppealListPaginatedResult | undefined;
  loading: boolean;
  error: string | null;
  showInlineLoader: boolean;
}

export interface UseCaseAppealsTableDataReturn {
  caseAppealsState: CaseAppealsTableState;
  setCaseAppealsState: React.Dispatch<React.SetStateAction<CaseAppealsTableState>>;
  tableData: CaseAppealListRow[];
  setTableData: React.Dispatch<React.SetStateAction<CaseAppealListRow[]>>;
}

/**
 * Manages Case Appeals table fetch state and raw API row data.
 *
 * @returns Table state, row data, and setters for the appeals page
 */
export const useCaseAppealsTableData = (): UseCaseAppealsTableDataReturn => {
  const [tableData, setTableData] = useState<CaseAppealListRow[]>([]);
  const [caseAppealsState, setCaseAppealsState] = useState<CaseAppealsTableState>(
    {
      data: undefined,
      loading: false,
      error: null,
      showInlineLoader: false,
    },
  );

  return {
    caseAppealsState,
    setCaseAppealsState,
    tableData,
    setTableData,
  };
};

/** @deprecated Use {@link useCaseAppealsTableData} */
export const useOncologySubmissionTableData = useCaseAppealsTableData;

/** @deprecated Use {@link CaseAppealsTableState} */
export type OncologySubmissionTableState = CaseAppealsTableState;
